export default __webpack_public_path__ + "static/media/beturus_mobile.f014bbd3.svg";